<template>
  <yioks-content @back="handleBack">
    <template v-slot:nav_left>
      <div class="nav-btn-box">
        <p class="btn active">申报评估考核阶段</p>
        <p class="btn" @click="toPath">历史文件库</p>
      </div>
    </template>
    <template v-slot:nav_right>
      <!-- <div v-if="!empty" class="yioks_btn" @click="handleSaveTemp">临时保存</div>
      <div v-if="!empty" class="yioks_btn" @click="handleAll">完成并提交</div> -->
    </template>

    <template v-slot:content_right>
      <div class="base-content-wrapper">
        <div class="content-inner-wrapper">
          <div class="list_wrap" v-if="!empty && !loading">
            <div class="tongji-wrapper">
              <vue-scroll>
                <div class="tongji-content">
                  <div class="progress-box">评估考核阶段已结束</div>
                </div>
              </vue-scroll>
            </div>
          </div>

          <yioks-empty v-if="empty" tips="暂时没有数据"></yioks-empty>
          <yioks-loading v-if="loading"></yioks-loading>

          <yioks-tips
            :showTip="isShowRefuseDialog"
            tipMsg="确认撤回提交的申报信息吗？"
            @callback="handleConfirmRefuse"
          ></yioks-tips>
        </div>
      </div>
    </template>
  </yioks-content>
</template>

<script>
import {
  orgAuditStageInfo,
  deleteTargetCompletedRevocation,
} from "@/api/performance";
import { opsHorizontal } from "@/utils/scrollIndialog";
import storage from "@/utils/storage";
import { ops } from "@/utils/scrollIndialog";
import { auditStateFilters } from "@/assets/js/yioksFilters";
import mixinAppConfig from "@/mixin/mixinAppConfig";
export default {
  mixins: [mixinAppConfig],
  components: {
    "yioks-tips": () => import("@/components/YioksTip"),
  },

  data() {
    return {
      ops,
      opsHorizontal: opsHorizontal(),
      empty: false,
      loading: false,
      auditInfo: {},
      submitedInfo: {},

      isShowRefuseDialog: false,
      refuseForm: {
        msg: "",
      },
      refuseFormRules: {},
      isAudited: false,
      activeStep: 1,
      expertProgress: 0,
    };
  },
  computed: {
    groupUuid() {
      const { groupUuid } = this.$route.query;
      return groupUuid;
    },
    stageUuid() {
      const { stageUuid } = this.$route.query;
      return stageUuid;
    },

    stageName() {
      const { stageName } = this.$route.query;
      return stageName;
    },

    stageType() {
      const { stageType } = this.$route.query;
      return Number(stageType) || 0;
    },

    secondStepName() {
      const clubConfig = this.$store.getters.sysHostType;
      if (clubConfig === "club") {
        return "专家审核";
      } else {
        return "区级审核";
      }
    },

    thirdStepName() {
      return "最终确认";
    },
  },

  // filters: {
  //   auditStateFilters
  // },

  created() {
    // this.loadOrgAuditInfo();
  },

  methods: {
    auditStateFilters,
    handleBack() {
      this.$router.push("/");
    },

    loadOrgAuditInfo() {
      const paramsData = {
        stageUuid: this.stageUuid,
      };
      this.loading = true;
      orgAuditStageInfo(paramsData)
        .then((res) => {
          this.loading = false;
          if (res) {
            const { expertAuditSum, expertSum, orgAuditStageLog, submit } = res;
            if (orgAuditStageLog && orgAuditStageLog.uuid) {
              // 已审核
              this.auditInfo = orgAuditStageLog;
              this.isAudited = true;
              if (
                this.auditInfo.auditType == 1 ||
                this.auditInfo.auditType == 3
              ) {
                this.activeStep = 2; // 完成初审
              } else if (this.auditInfo.auditType == 2) {
                this.activeStep = 3; // 完成终审
              } else {
                this.activeStep = 1; // 其他状态默认第一步
              }
            } else {
              // 仅提交，未审核
              this.isAudited = false;
              this.activeStep = 1;
            }
            if (expertAuditSum && expertSum) {
              this.expertProgress = (
                (expertAuditSum / expertSum) *
                100
              ).toFixed(0);
            }
            this.submitedInfo = submit;
          } else {
            this.empty = true;
          }

          // console.log('this.activeStep', this.activeStep)
        })
        .catch((err) => {
          this.loading = false;
          console.error("err", err);
        });
    },

    handleRefuse() {
      this.isShowRefuseDialog = true;
    },

    handleConfirmRefuse(flag, ok) {
      if (flag) {
        deleteTargetCompletedRevocation(this.stageUuid)
          .then((res) => {
            this.isShowRefuseDialog = false;
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            this.$router.push({
              path: "uploadHome",
              query: {
                groupUuid: this.groupUuid,
                stageUuid: this.stageUuid,
                targetName: this.targetName,
                stageType: 0, // 撤回后请重新选择类型
              },
            });
          })
          .catch((err) => {
            console.error("err", err);
          });
      } else {
        console.log("cancel", "");
        this.isShowRefuseDialog = false;
      }
      // console.log('tag', '')
    },

    // 跳转
    toPath() {
      this.$router.push({
        path: "phaselist",
        query: {
          activeCom: "document-library",
          statusUrl: JSON.stringify(this.$route.fullPath),
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.content-inner-wrapper
  height 560px
  .select_wrap
    padding 20px 40px 20px
    min-height 40px
    display flex
    justify-content space-between
    width 100%
    .nav-btn
      width 50px
      display flex
      align-items center
      justify-content center
      cursor pointer
    .tag-box
      // flex 1
      width 680px
      margin 0 auto
      .scroll-wrapper
        display flex
        align-items center
        justify-content flex-start
        position absolute
    .tag-box1
      flex 1
      height 40px
.list_wrap
  flex 1
  overflow hidden
  .tongji-wrapper
    height 500px
    display flex
    flex-direction column
    align-items center
    justify-content center
    .tongji-content
      height: 500px
      display flex
      flex-direction column
      align-items center
      justify-content center
      .info-box
        display flex
        align-items center
        justify-content center
        margin 15px 0
        padding 0 100px
      .btn-box
        display flex
        align-items center
        justify-content center
.footer-btns
  width 60%
  display flex
  justify-content space-around
  margin 0 auto
.r-form
  /deep/.el-dialog__body
    padding 20px 40px 20px 20px
.btn-box
  font-size $font_size_big
.btn-span
  cursor pointer
  user-select none
  color $green_color
.progress-box
  height 60px
  display flex
  align-items center
  justify-content center
  font-size 1.8em
  margin-top 80px
  &.n-mt
    margin-top 0px
    margin-bottom 20px
</style>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.nav-btn-box
  display flex
  .btn
    margin-right 20px
    padding 10px 15px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
.steps-box
  border 2px solid $green_color
  box-sizing border-box
  margin 120px 20px 10px
  padding-bottom 20px
  border-radius 4px
  /deep/.el-steps--simple
    background none
  .el-step__title
    /deep/&.is-process
      color #fff
  .el-step__icon
    /deep/&.is-process
      color #fff !important
  .el-step__title
    /deep/&.is-wait
      color #ccc !important
  /deep/.el-step__head.is-process
    color #fff !important
    border-color #fff !important
  /deep/.el-step__head.is-wait
    color #ccc !important
    border-color #ccc !important
</style>
